exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".body-4ba885fe{display:flex;justify-content:center}.footer-ca9b9012{display:flex}.embedCode-1b2c62bf{width:100%;height:150px;padding:10px}\n", ""]);

// Exports
exports.locals = {
	"body": "body-4ba885fe",
	"footer": "footer-ca9b9012",
	"embedCode": "embedCode-1b2c62bf"
};